import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/auth';
import { IContactCRMSearchData, UserInfo } from '@interfaces';
import { NewContractPymesService } from '../../../services/new-contract-pymes.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-user-selection-new-contract',
  templateUrl: './user-selection-new-contract.component.html',
  styleUrls: ['./user-selection-new-contract.component.scss']
})
export class UserSelectionNewContractComponent implements OnInit, OnDestroy {
  @Output() contactoCRM: EventEmitter<string> = new EventEmitter();
  @Input() user: UserInfo = null;
  public destroyed$: Subject<boolean> = new Subject<boolean>();
  public userDataForm: FormGroup;
  public results: IContactCRMSearchData = null;
  public reseted = true;
  public numberItems = 10;
  public showItems: number = this.numberItems;
  public role: string;

  constructor(
    private auth: AuthService,
    private formBuilder: FormBuilder,
    private newContractPymesService: NewContractPymesService,
    private cdRef: ChangeDetectorRef,
    private utilService: UtilService
  ) { }

  ngOnInit(): void {
    this.userDataForm = this.formBuilder.group({
      crm_option: [null, [Validators.required]],
      search: ['', null],
      crm_comm_option: ['', null]
    });
    this.userDataForm.get('search').valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(selectedValue => {
      this.userDataForm.controls.search.setErrors(null);
    });
    this.translateRole();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private translateRole(): void {
    switch (this.auth.getRole().code) {
      case '300000003':
        this.role = 'USER_MANAGEMENT.CHANNEL_MANAGER';
        break;
      case '300000004':
        this.role = 'USER_MANAGEMENT.CHANNEL_COMMERCIAL';
        break;
      case '300000005':
        this.role = 'USER_MANAGEMENT.CHANNEL_BACKOFFICE';
        break;
      case '300000006':
        this.role = 'USER_MANAGEMENT.CHANNEL_MASTER';
        break;
      case '300000007':
        this.role = 'USER_MANAGEMENT.CHANNEL_ACCIONA';
        break;
    }
  }

  public reset(): void {
    this.userDataForm.controls.search.setValue('');
    this.reseted = true;
  }

  public onChangeCRMOption(e): void {
    if (e.value === '0') {
      this.contactoCRM.emit(this.auth.getUserData().contactoCRM);
    } else {
      this.contactoCRM.emit(null);
      this.search(true);
    }
  }

  public onChangeCRMCommOption(e): void {
    this.contactoCRM.emit(e.value);
  }

  public onChangeSearch(e): void {
    this.reseted = true;
  }

  public showMoreResults(): void {
    this.showItems += this.numberItems;
  }

  public search(init: boolean): void {
    this.reseted = this.userDataForm.controls.search.value === '' ? true : init;
    const params = {
      PageNumber: 1,
      NumOfElements: 1000000,
      Filter: this.userDataForm.controls.search.value
    };
    this.newContractPymesService.getComercialesGestor(params).pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        if (res.success) {
          this.results = res.data;
          this.cdRef.detectChanges();
        } else {
          delete this.results;
          this.utilService.toastErrors(res);
        }
      },
      error => {
        this.utilService.toastErrors(error);
      }
    );
  }
}
